import React, { useState } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { useApp } from '../context/AppContext';

// Avisos de LICENCIA vencida (Corredata). El estado lo calcula AppContext a partir de
// `cont_config.licencia_vence` (ver estadoLicencia). Textos pedidos por Ricardo
// (2026-10-03): que el cliente sepa que se venció y cuántos días de gracia le quedan.

const dias = (n) => `${n} día${n === 1 ? '' : 's'}`;
const ACCION = 'Actualiza la información de pago o contáctate con el equipo de Corredata para activar tu plan.';

// Días de gracia: se trabaja normal, con una franja fija arriba y un aviso al entrar.
export function LicenciaAviso() {
  const { licencia } = useApp();
  const clave = licencia ? `licencia_aviso_${licencia.vence}_${licencia.restantes}` : null;
  const [abierto, setAbierto] = useState(() => {
    if (!clave) return false;
    try { return sessionStorage.getItem(clave) !== '1'; } catch { return true; }
  });
  if (!licencia || licencia.bloqueada) return null;
  const cerrar = () => { try { sessionStorage.setItem(clave, '1'); } catch { /* sin almacenamiento */ } setAbierto(false); };
  const texto = `Tu licencia ha vencido el día ${licencia.vence}. ${ACCION} Te quedan ${dias(licencia.restantes)} para perder acceso total a la plataforma.`;

  return (
    <>
      <div style={{ padding: '10px 18px', fontSize: 13, fontWeight: 600, color: 'var(--text-warning)', background: 'rgba(245,158,11,0.12)', borderBottom: '1px solid rgba(245,158,11,0.35)', display: 'flex', gap: 8, alignItems: 'center' }}>
        <AlertCircle size={15} style={{ flexShrink: 0 }} /> {texto}
      </div>
      {abierto && (
        <div className="modal-overlay" onClick={cerrar}>
          <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
            <div style={{ padding: '20px 22px', display: 'grid', gap: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 17, fontWeight: 800, color: 'var(--text-warning)' }}>
                  <AlertCircle size={20} /> Tu licencia ha vencido
                </div>
                <button className="btn btn-sm btn-secondary" onClick={cerrar}><X size={15} /></button>
              </div>
              <div style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.55 }}>{texto}</div>
              <button className="btn btn-primary" onClick={cerrar}>Entendido</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// Gracia cumplida: no se entra al sistema. Los datos siguen guardados.
export function LicenciaBloqueada() {
  const { licencia, logout } = useApp();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--navy)' }}>
      <div style={{ maxWidth: 480, width: '100%', padding: '28px 26px', borderRadius: 14, background: 'rgba(var(--sky-rgb),0.06)', border: '1px solid rgba(239,68,68,0.35)', display: 'grid', gap: 14 }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 19, fontWeight: 800, color: 'var(--text-danger)' }}>
          <AlertCircle size={22} /> Acceso suspendido
        </div>
        <div style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.6 }}>
          Tu licencia venció el día <b>{licencia?.vence}</b> y el período de gracia terminó. {ACCION}
        </div>
        <div style={{ fontSize: 13, color: 'var(--silver)' }}>Tu información está guardada: al activar tu plan vuelves a entrar como siempre.</div>
        <button className="btn btn-secondary" onClick={logout}>Cerrar sesión</button>
      </div>
    </div>
  );
}
